export default __webpack_public_path__ + "static/media/Mail.0c740a33.svg";